import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

// The dramatic beat that shifts the experience from CONFRONTATION to REVELATION.
// stage 0: converging red/cyan "reading" pulse. stage 1: monolithic statement.

export default function TasteReveal({ reducedMotion, onDone }) {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), reducedMotion ? 400 : 1000);
    const t2 = setTimeout(() => onDone(), reducedMotion ? 1100 : 2600);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [reducedMotion, onDone]);

  return (
    <button
      type="button"
      data-testid="reveal-beat"
      onClick={onDone}
      className="relative flex flex-col items-center justify-center h-[100dvh] w-full overflow-hidden focus:outline-none"
      aria-label="Continue to your taste profile"
    >
      {/* Converging confrontation glows collapsing into one identity */}
      <motion.div
        aria-hidden
        className="absolute w-[70vw] h-[70vw] rounded-full blur-[90px]"
        style={{ background: "var(--tt-left)", opacity: 0.18 }}
        initial={{ x: "-40vw" }}
        animate={{ x: stage >= 1 ? 0 : "-18vw" }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.div
        aria-hidden
        className="absolute w-[70vw] h-[70vw] rounded-full blur-[90px]"
        style={{ background: "var(--tt-right)", opacity: 0.18 }}
        initial={{ x: "40vw" }}
        animate={{ x: stage >= 1 ? 0 : "18vw" }}
        transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
      />

      <AnimatePresence mode="wait">
        {stage === 0 ? (
          <motion.div
            key="reading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="relative z-10 flex flex-col items-center"
          >
            <div className="w-2.5 h-2.5 rounded-full bg-bone tt-breathe" />
            <p className="mt-6 font-mono text-[11px] tracking-[0.35em] uppercase text-silver">
              Reading your choices
            </p>
          </motion.div>
        ) : (
          <motion.div
            key="statement"
            initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 18, filter: "blur(6px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative z-10 px-8 text-center"
          >
            <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-silver mb-4">
              We found
            </p>
            <h1 className="font-display font-black uppercase leading-[0.95] tracking-[-0.03em] text-bone text-5xl sm:text-6xl">
              Your<br />Taste.
            </h1>
            <p className="mt-8 font-body text-xs tracking-[0.2em] uppercase text-white/40">
              Tap to continue
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
